import React from 'react'



const AddtoCard = () => {
return(
  <section className='bg-xiketic p-12 pb-36'>
      <h1 className='mb-7 text-md'>Cart is Empty</h1>
     
  </section>
);
  
    
  
};

export default AddtoCard;
